module.exports = __webpack_public_path__ + "static/media/icon4.acb53e47.svg";